module.exports = __webpack_public_path__ + "eaa48a7b09f0bfa671b44a7d5413560f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Faceted Trapezoid@2x.png
// module id = 318
// module chunks = 0